export const scormTest = (
    phrases,
    assignmentId,
    testId,
    isCompatibleBrowserTest,
    asyncScorm,
    setiFrameShow,
    closeRTE,
    closeRTEAsync
) => {
    let dateInit = new Date();
    let statusSCO = "";
    let exitSCO = "";
    let isFinish = false;

    let RequestObject = {
        assignmentId: assignmentId,
        testId: testId,
    };

    let isChrome = isCompatibleBrowserTest();

    

    let API_XPERT = {
        version: "1.0", // mandatory version attribute

        // SCO RTE functions
        LMSInitialize: function () {
            statusSCO = "";
            exitSCO = "";
            let ret;

            let resp = asyncScorm("lmsInitialize", RequestObject, false);

            if (resp !== null) {
                ret = resp.scormValue;
            }

            return ret;
        },

        LMSFinish: async function () {
            setiFrameShow(false);

            let now = new Date();
            let durationTime = Math.round(
                (now.getTime() - dateInit.getTime()) / 1000
            ).toString();
            let host = window.location.hostname;
            let domain = "xpert.adeccogroup.com";
            isFinish = true;

            if (host != null && host != "") {
                let prefix = host.indexOf(".");
                domain = host.substring(prefix + 1, host.length);
            }

            let ret;
            //let isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
            if (!isChrome) {
                //continue as is
                let resp = await asyncScorm("exitSCO", RequestObject, false);

                if (resp !== null) {
                    exitSCO = resp.scormValue;
                }

                resp = await asyncScorm("statusSCO", RequestObject, false);

                if (resp !== null) {
                    statusSCO = resp.scormValue;
                }

                RequestObject.durationTime = durationTime;
                RequestObject.domain = domain;

                resp = await asyncScorm("lmsFinish", RequestObject, false);

                if (resp !== null) {
                    ret = resp.scormValue;
                }
                
                await closeRTE(exitSCO,statusSCO,RequestObject);

                return "true";
            } else {
                //handle chrome block async issue
                /* jshint ignore:start */
                (async function (dataobject) {
                    let resp = await fetch("/rest/scorm/exitSCO", {
                        method: "POST",
                        headers: {
                            "x-xpert-session": dataobject.assignmentId,
                            "Content-Type": "application/json; charset=utf-8",
                        },
                        body: JSON.stringify(dataobject),
                    });
                    let respjson = await resp.json();
                    if (respjson !== null) {
                        exitSCO = respjson.scormValue;
                    }

                    resp = await fetch("/rest/scorm/statusSCO", {
                        method: "POST",
                        headers: {
                            "x-xpert-session": dataobject.assignmentId,
                            "Content-Type": "application/json; charset=utf-8",
                        },
                        body: JSON.stringify(dataobject),
                    });
                    respjson = await resp.json();
                    if (respjson !== null) {
                        statusSCO = respjson.scormValue;
                    }

                    RequestObject.durationTime = durationTime;
                    RequestObject.domain = domain;

                    resp = await fetch("/rest/scorm/lmsFinish", {
                        method: "POST",
                        headers: {
                            "x-xpert-session": dataobject.assignmentId,
                            "Content-Type": "application/json; charset=utf-8",
                        },
                        body: JSON.stringify(dataobject),
                    });

                    await closeRTEAsync(exitSCO,statusSCO,RequestObject);

                    return "true";
                })(RequestObject);
                /* jshint ignore:end */
                return "true";
            }
        },

        LMSGetValue: function (name) {
            RequestObject.element = name;

            let response = asyncScorm("lmsGetValue", RequestObject, false);

            if (response != null) {
                return response.scormValue;
            }
        },

        LMSSetValue: function (name, value) {
            let ret;

            RequestObject.element = name;
            RequestObject.value = value;

            let response = asyncScorm("lmsSetValue", RequestObject, false);

            if (response != null) {
                ret = response.scormValue;
            }

            if ("false" == ret && name.indexOf(".id") != -1) {
                alert(phrases?.["10022020"] + "\n\n" + phrases?.["10022021"]);
                setiFrameShow(false);

                setTimeout(function () {
                    closeRTE();
                }, 3000);
                return "true";
            }
            return ret;
        },

        LMSCommit: function () {
            //let isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
            if (!isChrome) {
                //continue as is
                let response = asyncScorm("lmsCommit", RequestObject, false);

                if (response!= null) {
                    return response.scormValue;
                }
            } else {
                //handle chrome block async issue
                /* jshint ignore:start */
                (async function (dataobject) {
                    let resp = await fetch("/rest/scorm/lmsCommit", {
                        method: "POST",
                        headers: {
                            "x-xpert-session": dataobject.assignmentId,
                            "Content-Type": "application/json; charset=utf-8",
                        },
                        body: JSON.stringify(dataobject),
                    });
                    let respjson = await resp.json();
                    if (respjson != null) {
                        ret = respjson.scormValue;
                    }
                })(RequestObject);
                /* jshint ignore:end */
                return true;
            }
        },

        LMSGetDiagnostic: function (errCode) {
            RequestObject.errorCode = errCode;

            let response = asyncScorm("LMSGetDiagnostic", RequestObject, false);

            if (response != null) {
                return response.scormValue;
            }
        },

        LMSGetErrorString: function (errCode) {
            RequestObject.errorCode = errCode;

            let response = asyncScorm(
                "lmsGetErrorString",
                RequestObject,
                false
            );

            if (response!= null) {
                return response.scormValue;
            }
        },

        LMSGetLastError: function () {
            let response = asyncScorm("lmsGetLastError", RequestObject, false);

            if (response != null) {
                return response.scormValue;
            }
        },
    };

    return API_XPERT;
};
